import report from './guides/report';
import documenti from './guides/documenti';
import richieste from './guides/richieste';
import noteSpese from './guides/note-spese';
import cartellino from './guides/cartellino';
import anagrafiche from './guides/anagrafiche';
import trasparenza from './guides/trasparenza';

/**
 * Guide operative HeyJob (company), pubblicate nelle News.
 * Per ogni guida: un file in guides/ e una schermata per passo in sections/guides/screens.
 */
const GUIDE_CATALOG = [cartellino, anagrafiche, documenti, richieste, noteSpese, report, trasparenza];

// La guida successiva da proporre dipende da chi legge: vedi getNextGuide in visibility.js.
export function getProductGuides() {
  return GUIDE_CATALOG;
}

export function getProductGuideBySlug(slug) {
  return GUIDE_CATALOG.find((guide) => guide.slug === slug) ?? null;
}
